import React, { createContext, useEffect, useState } from 'react';

type User = {
    id?: number;
    username?: string;
    email?: string;
    fullName?: string;
    tenantId?: number | null;
    tenantName?: string | null;
};

type UserContextType = {
    user: User | null;
    token: string | null;
    setUserContext: (user: User | null, token?: string | null) => void;
    clearUserContext: () => void;
};

export const UserContext = createContext<UserContextType>({
    user: null,
    token: null,
    setUserContext: () => { },
    clearUserContext: () => { }
});

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<User | null>(() => {
        try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
    });
    const [token, setToken] = useState<string | null>(() => localStorage.getItem('token'));

    useEffect(() => {
        if (user) localStorage.setItem('user', JSON.stringify(user)); else localStorage.removeItem('user');
    }, [user]);

    useEffect(() => {
        if (token) localStorage.setItem('token', token); else localStorage.removeItem('token');
    }, [token]);

    const setUserContext = (u: User | null, t: string | null = null) => {
        setUser(u);
        setToken(t);
    };

    const clearUserContext = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('tenantId');
    };

    return (
        <UserContext.Provider value={{ user, token, setUserContext, clearUserContext }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
